import { Http } from '@gamiphy/http';

type Strings = {
  [key: string]: string,
}

export class StringsApi {
  public static async getStrings(): Promise<Strings> {
    if (Http.getGamixAppId()) {
      const response = await Http.get<Strings>({
        url: 'v1/strings',
      });

      return response.data;
    }

    return {};
  }
}
